import { TypeOfReportsListObj } from './customReportTypes';

const reportsArray = [
  {
    description: bfTranslate('User engagement with assets, including views, downloads and shares.'),
    reportName: bfTranslate('User Engagement With Assets'),
    reportUrl: 'user-engagement-with-assets'
  },
  {
    description: bfTranslate('See your top-performing assets including views, shares, and downloads. Provides good indicators of healthy and active assets.'),
    reportName: bfTranslate('Asset Performance By Brandfolder'),
    reportUrl: 'asset-performance-by-brandfolder'
  },
  {
    description: bfTranslate('See your most and least active users.'),
    reportName: bfTranslate('User Activity by Organization'),
    reportUrl: 'user-activity-by-organization'
  },
  {
    description: bfTranslate('Top-performing Brandfolders and Collections based on all asset activity within them.'),
    reportName: bfTranslate('Brandfolder and Collection Activity'),
    reportUrl: 'brandfolder-and-collection-activity'
  },
  {
    description: bfTranslate('See your most and least active share links.'),
    reportName: bfTranslate('Share Link Activity'),
    reportUrl: 'share-link-activity'
  },
  {
    description: bfTranslate('Shows when a user was last active in your Brandfolder. Can be used to reallocate your organization’s seats.'),
    reportName: bfTranslate('User Last Active Date'),
    reportUrl: 'user-last-active-date'
  },
  {
    description: bfTranslate('Shows what your users are searching for.'),
    reportName: bfTranslate('Popular Search Terms'),
    reportUrl: 'popular-search-terms'
  },
  {
    description: bfTranslate('View unique resource page views.'),
    reportName: bfTranslate('Unique Page Views'),
    reportUrl: 'unique-page-views'
  },
  {
    description: bfTranslate('View CDN link activity by both hits and bandwidth usage.'),
    reportName: bfTranslate('CDN Link Activity'),
    reportUrl: 'cdn-link-activity'
  }
];

const getCorrectReportsArray = (): TypeOfReportsListObj[] => {
  if (BFG.hasFeature('embed_asset')) {
    return reportsArray;
  } else {
    return reportsArray.filter((report) => report.reportUrl !== 'cdn-link-activity');
  }
};

export const reportsList = getCorrectReportsArray();